import "./Shoes.css"
import Product1 from "../Components/Product1"
import Shoes1 from "../images/shoes1.jpg"
import Shoes2 from "../images/shoes2.jpg"
import Shoes3 from "../images/shoes3.jpg"
import Shoes4 from "../images/shoes4.jpg"
import Shoes5 from "../images/shoes5.jpg"
import Shoes6 from "../images/shoes6.jpg"
import Shoes7 from "../images/shoes7.jpg"
import Shoes8 from "../images/shoes8.jpg"
import Shoes9 from "../images/shoesmadd.jpg"

export default function Shoes() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Shoes9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="shoe1"prdName="WHITE SNEAKERS" img={Shoes1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="shoe2" prdName="FORMAL LOAFER" img={Shoes2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1> 

          </div>

          <div className="home__prd1">

          
          <Product1  id="shoe3"prdName="SHAKKY LOAFER" img={Shoes3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="shoe4"prdName="CANVAS" img={Shoes4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="shoe5"prdName="CAMPUS SPORTS SHOE" img={Shoes5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="shoe6"prdName="ADDIDAS SPORTS SHOE" img={Shoes6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="shoe7" prdName="CLARKS LOAFER" img={Shoes7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="shoe8"prdName="FORMAL CANVAS" img={Shoes8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}